import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileSheet = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4491_6108",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#232930"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_4491_6108)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 3C19.55 3 20.0204 3.19622 20.4121 3.58789C20.8038 3.97956 21 4.45 21 5V19C21 19.55 20.8038 20.0204 20.4121 20.4121C20.0204 20.8038 19.55 21 19 21H5C4.45 21 3.97956 20.8038 3.58789 20.4121C3.19622 20.0204 3 19.55 3 19V5C3 4.45 3.19622 3.97956 3.58789 3.58789C3.97956 3.19622 4.45 3 5 3H19ZM7 15.8887C7 16.1942 7.10858 16.4562 7.32617 16.6738C7.54376 16.8914 7.80577 17 8.11133 17H11.4443V14.2227H7V15.8887ZM12.5557 17H15.8887C16.1942 17 16.4562 16.8914 16.6738 16.6738C16.8914 16.4562 17 16.1942 17 15.8887V14.2227H12.5557V17ZM7 13.1113H11.4443V10.333H7V13.1113ZM12.5557 13.1113H17V10.333H12.5557V13.1113ZM8.11133 7C7.80577 7 7.54376 7.10858 7.32617 7.32617C7.10858 7.54376 7 7.80577 7 8.11133V9.22266H17V8.11133C17 7.80577 16.8914 7.54376 16.6738 7.32617C16.4562 7.10858 16.1942 7 15.8887 7H8.11133Z",
			fill: "#232930"
		})
	})]
});
export default SvgFileSheet;
